"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RequiresFlag = ({ children, active }) => {
    if (active) {
        return children;
    }
    return null;
};
exports.default = RequiresFlag;
